<template>
    <div class="hobby">
       <div class="title">
         <p5-title content="Hobbies" size="extra-large"></p5-title>
       </div>
       <div class="dialog">
         <div class="icon">
           <p5-icon type='party' name="alibaba" />
         </div>
         <div class="log">
           <div class="content">
             <p5-text size="large">趣味はいろいろなゲイムです。</p5-text>
           </div>
         </div>
       </div>
       
       <div class="dialogImg">
        <div class="img1"></div>
        <div class="img2"></div>
        <div class="img3"></div>
       </div>
 
       <div class="dialog">
         <div class="icon">
           <p5-icon type='party' name="alibaba" />
         </div>
         <div class="log">
           <div class="content">
             <p5-text size="large">音楽と映画も好きです。</p5-text>
           </div>
         </div>
       </div>
     </div>
 </template>
 
 <script>
 export default {
   name: 'Hobby'
 }
 </script>
 
 <style>
 .hobby{
   margin: 220px 100px 0px 240px;
   height: calc(100% - 220px);
   width: 100%;
   overflow: auto;
 }
 .hobby .p5-svg-party {
   width: 150px;
   height: 150px;
 }
 .hobby .title{
   position: absolute;
   top: 115px;
   left: 800px;
   transform: rotate(8deg);
 }
 .hobby .dialog{
   height: 200px;
   width: 1200px;
 }
 .hobby .dialogImg{
   height: 572px;
   width: 1200px;
 }
 .hobby .text-size-extra-large {
   display: block;
   font-size: 44px;
   text-align: center;
 }
 .hobby .icon{
   float: left;
   margin: 0px -25px 0px 150px;
 }
 .hobby .log{
   float: left;
   height: 158px;
   width: 700px;
   background: url("../assets/log.png") no-repeat;
   background-size: cover;
 }
 .hobby .log_img{
   float: left;
   height: 400px;
   width: 700px;
   background: url("../assets/log.png") no-repeat;
   background-size: cover;
 }
 .hobby .log .content{
   position: relative;
   top:60px;
   left: 135px;
 }
 .hobby .log .content_large{
   position: relative;
   top: 48px;
   left: 135px;
   width: 450px;
 }
 .hobby .img1{
  position: relative;
  float: left;
  background: url("../assets/MHW.jpg") no-repeat;
  background-size: cover;
  width: 478px;
  height: 269px;
  top: 12px;
left: 379px;
transform: rotate(4deg);
 }
 .hobby .img2{
  position: relative;
  float: left;
  background: url("../assets/P5R.jpg") no-repeat;
  background-size: cover;
  width: 478px;
  height: 269px;
  top: 132px;
  left: -258px;
  transform: rotate(-7deg);
 }
 .hobby .img3{
  position: relative;
  float: left;
  background: url("../assets/GTA.jpg") no-repeat;
  background-size: cover;
  width: 478px;
  height: 269px;
  top: -9px;
  left: 339px;
 }
   </style>